import type { FC } from "react";

import type { AddressStored } from "@jti/fe-common";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import { AddressCard } from "../AddressCard";
import { AddressForm } from "../AddressForm";
import { Line } from "../Line";

import styles from "./AddressDeliveryDetails.module.scss";

export type AddressDeliveryDetailsProps = {
  userAddress?: AddressStored;
  onEditAddress?: () => void;
};

export const AddressDeliveryDetails: FC<AddressDeliveryDetailsProps> = ({ userAddress, onEditAddress }) => {
  const { __ } = useTranslations();
  return (
    <>
      <Line />
      <h3 className={styles.deliveryDetailsText}>{__(`loyalty.redeemDialog.shippingDetailsSectionLabel`)}</h3>
      {userAddress ? (
        <AddressCard
          address={userAddress}
          editButtonLabel={__(`loyalty.redeemDialog.editAddressButtonText`)}
          title={__(`loyalty.redeemDialog.shippingDetailsLabel`)}
          onEdit={onEditAddress}
        />
      ) : (
        <AddressForm />
      )}
    </>
  );
};
